<p-button
  (click)="columnSettingsPopover.toggle($event)"
  [pTooltip]="'travelBoards.customizeColumns' | transloco"
  tooltipPosition="top"
  [tooltipOptions]="{ showDelay: 500 }"
  icon="pi pi-cog"
  [text]="true"
  size="small"
/>
<p-popover #columnSettingsPopover>
  <div class="flex min-w-[260px] max-w-[300px] flex-col p-1">
    <div class="mb-3 flex flex-col gap-1 border-b border-greyscale-100 pb-3">
      <div class="flex items-center gap-2">
        <i class="pi pi-cog text-primary-500"></i>
        <span class="text-sm font-semibold text-greyscale-800">
          {{ "travelBoards.customizeColumns" | transloco }}
        </span>
      </div>
      <p class="text-xs leading-snug text-greyscale-500">
        {{ "travelBoards.customizeColumnsDescription" | transloco }}
      </p>
    </div>
    <div class="flex flex-col gap-2">
      @for (col of tableSettingService.toggleableColumns; track col.key) {
        @if (
          col.key !== "companyClients" ||
          packLimitationService.canFilterClient()
        ) {
          <label
            class="flex cursor-pointer items-center gap-2 rounded px-1 py-1 transition-colors hover:bg-greyscale-50"
          >
            <input
              type="checkbox"
              class="h-4 w-4 cursor-pointer accent-primary-500"
              [checked]="tableSettingService.isColumnVisible(col.key)"
              (change)="tableSettingService.toggleColumn(col.key, $event)"
            />
            <span class="text-sm text-greyscale-700">
              {{ col.labelKey | transloco }}
            </span>
          </label>
        }
      }
    </div>
  </div>
</p-popover>
